import { css, cx } from '@eti/styles';
import { ReactComponent as ToiletIcon } from '@eti/assets/icons/c_flat-toilet.svg';
import { vars } from '@etg/wings';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const styles = css`
  rect {
    fill: ${vars.colors.inputs.border};
  }
`;
const Toilet = () => /*#__PURE__*/_jsx(ToiletIcon, {
  className: cx(styles, rowItemSize)
});
export default Toilet;
//# sourceMappingURL=Toilet.js.map